export default __webpack_public_path__ + "static/img_product_popreader-57aff01f72913f08e28e03391bb68f88.png";